import React from "react";
var Link = function Link(_ref) {
  var href = _ref.href,
    styleName = _ref.styleName,
    content = _ref.content,
    target = _ref.target;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: styleName,
    dangerouslySetInnerHTML: {
      __html: content
    },
    target: target
  });
};
export default Link;